import { useTranslation } from 'react-i18next';
import { CardHeader } from '@statsbomb/kitbag-components';
import { PitchSelectVideoPlayer } from '@/components/video/PitchSelectVideoPlayer';
import { VideoPlayerHeader } from '@/components/video/VideoPlayerHeader';
import { CloseCardHeaderButton } from '@/components/button/CloseCardHeaderButton';

export const PitchSelectVideoPreview = ({ ids }: { ids?: Record<string, string | number> }) => {
  const { t } = useTranslation('video');
  const title = t('player');

  return (
    <>
      <CardHeader>
        <VideoPlayerHeader title={title} ids={ids} />
        <CloseCardHeaderButton navigationPath=".." />
      </CardHeader>
      <PitchSelectVideoPlayer />
    </>
  );
};
